<div class="security-panel">
  <div class="operations-section-header mb-3">
    <div>
      <p class="operations-eyebrow mb-1">Risk Context</p>
      <h5 class="security-title mb-0">Security, Demographics &amp; Competition</h5>
    </div>
    <span class="operations-pill operations-pill-warning">
      {{ crimeStats.crimeIndex || 'Unknown' }} risk
    </span>
  </div>

  <div class="security-metric-grid">
    <div class="security-metric">
      <span class="security-metric-label">Precinct</span>
      <strong>{{ crimeStats.precinct || 'Local' }}</strong>
    </div>
    <div v-if="crimeStats.periodIncrease" class="security-metric">
      <span class="security-metric-label">Trend</span>
      <strong :class="crimeStats.periodIncrease.includes('increase') ? 'text-danger' : 'text-success'">
        {{ crimeStats.periodIncrease }}
      </strong>
    </div>
    <div v-if="crimeStats.stationContact" class="security-metric">
      <span class="security-metric-label">Police Contact</span>
      <strong>{{ crimeStats.stationContact }}</strong>
    </div>
    <div v-if="crimeStats.lastUpdated" class="security-metric">
      <span class="security-metric-label">Updated</span>
      <strong>{{ crimeStats.lastUpdated }}</strong>
    </div>
  </div>

  <div class="security-list-header">
    <span>{{ crimeStats.precinct || 'Local' }} Crime Statistics</span>
    <span v-if="crimeStats.incidentSummary && crimeStats.incidentSummary.length > 0">
      {{ crimeStats.incidentSummary.reduce((sum, crime) => sum + crime.count, 0) }} cases
    </span>
  </div>

  <div class="security-incident-list">
    <div
      v-for="incident in dynamicIncidents"
      :key="incident.id"
      class="security-incident"
      :class="{
        'security-incident-critical': incident.severity === 'critical',
        'security-incident-high': incident.severity === 'high',
        'security-incident-info': incident.severity === 'info'
      }"
    >
      <div class="security-incident-body">
        <p class="mb-1 fw-semibold text-white text-xs">{{ incident.title }}</p>
        <p class="mb-0 text-white-50 text-xs">{{ incident.timestamp }}</p>
      </div>
      <div class="security-incident-meta">
        <span
          class="security-status"
          :class="{
            'security-status-success': incident.status === 'Analyzed',
            'security-status-warning': incident.status === 'Pending',
            'security-status-info': incident.status === 'No Data'
          }"
        >
          {{ incident.status }}
        </span>
        <span
          v-if="incident.trend"
          class="security-trend"
          :class="{
            'security-trend-good': incident.trend.startsWith('-'),
            'security-trend-bad': incident.trend.startsWith('+')
          }"
        >
          {{ incident.trend }}
        </span>
      </div>
    </div>
  </div>
</div>
